import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import Visa from "../assets/images/profile/visa.svg";
import MasterCard from "../assets/images/profile/master-card.svg";
import AmericanExpress from "../assets/images/profile/american-express.svg";
import Discover from '../assets/images/profile/discover.svg'  
//import Maestro from '../assets/images/profile/maestro.svg'
import { Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import PlusIcon from "../assets/images/profile/plus.svg";
import BackImg from "../assets/images/cart/back-icon.svg";
import PlusCircleIcon from '../assets/images/plus2.svg'
import BackArrow from '../assets/images/mobile-back-arrow.svg'
import EditIcon from "../assets/images/cart/edit-icon.svg";
import DeleteIcon from "../assets/images/cart/delete-icon.svg";
import Skeleton from "react-loading-skeleton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

import { useDispatch, useSelector } from "react-redux";
import { fetchUserCards, deleteUserCard, addUserCard, updateUserCard } from "../features/card/cardActions";
import { toast } from "react-toastify";


function PaymentInfoComp({onBack}) {
  const [isActive, setIsActive] = useState(false);

  const [formTitle, setFormTitle] = useState("Add New Credit/Debit Card");
  const [name, setName] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [expireDate, setExpireDate] = useState("");
  const [securityCode, setSecurityCode] = useState("");
  
  const [selectedCard, setSelectedCard] = useState(null);

  const [errors, setErrors] = useState({});

  const handleToggle = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    setIsActive(prevState => !prevState);
  };

  const resetCardForm = () => {
    setSelectedCard(null);
    setName("");
    setCardNumber("");
    setExpireDate("");
    setSecurityCode("");
    setErrors({});
    setFormTitle("Add New Credit/Debit Card");
  };

  const handleAddNewCard = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    resetCardForm();
    setIsActive(true);
  };

  const dispatch = useDispatch();
  const { cards, loading, successMessage, errorMessage } = useSelector(
    (state) => state.card
  );

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage, { autoClose: 5000, hideProgressBar: true, className: "toast-success" });
      setName("");
      setCardNumber("");
      setExpireDate("");
      setSecurityCode("");
      resetCardForm();
      setIsActive(false);
      let data = { page: 1, limit: 25 };
      dispatch(fetchUserCards(data));
    }
    if (errorMessage) {
      toast.error(errorMessage, { autoClose: 5000, hideProgressBar: true, className: "toast-error" });
    }
  }, [successMessage, errorMessage, dispatch]);

  useEffect(() => {
    let data = { page: 1, limit: 25 };
    dispatch(fetchUserCards(data));
  }, [dispatch, isActive]);

  const handleDelete = (id) => {
    dispatch(deleteUserCard(id));
  };

  // Helper function to convert YYYY-MM to MM-YYYY for display
  const formatExpireDateForDisplay = (dateString) => {
    if (!dateString || !dateString.includes("-")) {
      return dateString;
    }
    const [year, month] = dateString.split("-");
    if (year && month) {
      return `${month}-${year}`;
    }
    return dateString;
  };

  const validate = () => {
    const errors = {};

    // Check for empty fields
    if (!name) errors.name = "Name is required.";
    if (!cardNumber) errors.cardNumber = "Card number is required.";
    if (!expireDate) errors.expireDate = "Expire date is required.";
    if (!securityCode) errors.securityCode = "Security code is required.";

    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Initial blank errors
    setErrors({});

    // Validate form inputs
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // Dismiss any currently visible toasts
    toast.dismiss();

    // Convert MM-YYYY to YYYY-MM for API
    let apiExpireDate = expireDate;
    if (expireDate.includes("-")) {
      const [month, year] = expireDate.split("-");
      if (month && year) {
        apiExpireDate = `${year}-${month.padStart(2, "0")}`;
      }
    }

    // Dispatch
    let cardData = {
      name: name,
      card_number: cardNumber,
      expire_date: apiExpireDate,
      security_code: securityCode,
    };
    
    if (selectedCard) {
      // Update card logic
      dispatch(updateUserCard(selectedCard.id, cardData));
    } else {
      // Add new card logic
      dispatch(addUserCard(cardData));
    }
  };

  const handleCardNumberChange = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // Allow only numbers
    setCardNumber(value.slice(0, 16)); // Limit to 16 digits
  };

  const handleExpireDateChange = (e) => {
    let value = e.target.value.replace(/[^0-9-]/g, ""); // Allow only numbers and "-"
    
    // Remove existing dashes to rebuild format
    const parts = value.split("-");
    let month = parts[0] || "";
    let year = parts[1] || "";
    
    // Limit month to 2 digits
    if (month.length > 2) {
      month = month.slice(0, 2);
    }
    
    // Limit year to 4 digits
    if (year.length > 4) {
      year = year.slice(0, 4);
    }
    
    // Format as MM-YYYY
    let formattedValue = "";
    
    if (month.length > 0) {
      const monthNum = parseInt(month, 10);
      
      // If month is valid (1-12), format it with leading zero when appropriate
      if (monthNum > 0 && monthNum <= 12) {
        // If user has entered 2 digits for month, pad it
        if (month.length === 2) {
          formattedValue = month.padStart(2, "0");
        } else {
          formattedValue = month;
        }
      } else {
        formattedValue = month;
      }
      
      // Auto-add "-" after month when 2 digits are entered
      if (formattedValue.length === 2 && year.length === 0 && !value.includes("-")) {
        formattedValue = formattedValue + "-";
      } else if (year.length > 0) {
        formattedValue = formattedValue + "-" + year;
      }
    }
  
    formattedValue = formattedValue.slice(0, 7); // Ensure format stays within MM-YYYY
  
    // Validate that the entered date is in the future
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1; // JavaScript months are 0-based
  
    const monthNum = month ? parseInt(month, 10) : null;
    const yearNum = year ? parseInt(year, 10) : null;
  
    // Validate month is between 1-12
    if (monthNum && (monthNum < 1 || monthNum > 12)) {
      setErrors((prev) => ({
        ...prev,
        expireDate: "Month must be between 01 and 12",
      }));
    } else if (
      yearNum && monthNum &&
      (yearNum < currentYear || (yearNum === currentYear && monthNum < currentMonth))
    ) {
      setErrors((prev) => ({
        ...prev,
        expireDate: "Expiry date must be in the future",
      }));
    } else {
      setErrors((prev) => ({ ...prev, expireDate: "" }));
    }
  
    setExpireDate(formattedValue);
  };

  const handleExpireDateBlur = (e) => {
    // Format the month with leading zero on blur to ensure MM format
    let value = expireDate;
    if (value && value.includes("-")) {
      const [month, year] = value.split("-");
      if (month && month.length === 1) {
        const monthNum = parseInt(month, 10);
        if (monthNum > 0 && monthNum <= 12) {
          const formattedMonth = month.padStart(2, "0");
          setExpireDate(`${formattedMonth}-${year || ""}`);
        }
      } else if (month && month.length === 2) {
        const monthNum = parseInt(month, 10);
        if (monthNum > 0 && monthNum <= 12) {
          const formattedMonth = month.padStart(2, "0");
          setExpireDate(`${formattedMonth}-${year || ""}`);
        }
      }
    } else if (value && value.length === 1) {
      const monthNum = parseInt(value, 10);
      if (monthNum > 0 && monthNum <= 12) {
        setExpireDate(value.padStart(2, "0") + "-");
      }
    }
  };
  
  const handleSecurityCodeChange = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // Allow only numbers
    setSecurityCode(value.slice(0, 4)); // Limit to 4 digits
  };

  const handleEdit = (card) => {
    setSelectedCard(card); // Store selected card
    setName(card.card_name);
    
    // Convert YYYY-MM from API to MM-YYYY for display
    let displayExpireDate = card.expire_date;
    if (card.expire_date && card.expire_date.includes("-")) {
      const [year, month] = card.expire_date.split("-");
      if (year && month) {
        displayExpireDate = `${month}-${year}`;
      }
    }
    setExpireDate(displayExpireDate);
    setSecurityCode(""); // Keep CVV empty for security
    setFormTitle('Edit Credit/Debit Card')
    handleToggle(); // Show form
  };



  return (
    <>
       <div className={`${isActive ? 'isHide' : ''}`}>
      <div className="mobile-product-header d-flex d-md-none">
        <button type="button" className="mph-back" onClick={onBack}>
          <img src={BackArrow} alt="Back" />
        </button>
        <h1 className="mph-title">Payment Info</h1>
        <button type="button" className="mph-action mph-action--circle" onClick={handleAddNewCard}>
          <img src={PlusCircleIcon} alt="Add" />
        </button>
      </div>
      <div className="tab-content-header d-none d-md-flex">
          <h3>Payment Info</h3>
          <Link to="" className="cutsom-bttn" onClick={handleAddNewCard}>
            <img src={PlusIcon} alt="" /> Add New Card
          </Link>
        </div>
        <div className="tab-content-body">
          <div className="card-list">
            {loading ? ( // Show skeletons while loading
              <>
                {Array.from({ length: 4 }).map((_, index) => (
                  <div className="card-list-item" key={index}>
                    <div className="card-cell">
                      <Skeleton width={50} height={30} />
                    </div>
                    <div className="card-cell">
                      <span>
                        <Skeleton width={80} />
                      </span>
                      <h4>
                        <Skeleton width={120} />
                      </h4>
                    </div>
                    <div className="card-cell">
                      <span>
                        <Skeleton width={100} />
                      </span>
                      <h4>
                        <Skeleton width={150} />
                      </h4>
                    </div>
                    <div className="card-cell">
                      <span>
                        <Skeleton width={80} />
                      </span>
                      <h4>
                        <Skeleton width={120} />
                      </h4>
                    </div>
                    <div className="card-cell flex-row">
                      <Skeleton circle width={30} height={30} />
                      <Skeleton
                        circle
                        width={30}
                        height={30}
                        style={{ marginLeft: 10 }}
                      />
                    </div>
                  </div>
                ))}
              </>
            ) : cards?.data?.length > 0 ? ( // If cards exist, render them
              cards.data.map((row, index) => (
                <div className="card-list-item" key={index}>
                  <div className="card-cell">
                    <img
                      className="card-img"
                      src={
                        row.card_type === "visa"
                          ? Visa
                          : row.card_type === "mastercard"
                          ? MasterCard
                          : row.card_type === "amex"
                          ? AmericanExpress
                          : row.card_type === "discover"
                          ? Discover
                          : row.card_type === "diners"
                          ? AmericanExpress
                          : row.card_type === "jcb"
                          ? AmericanExpress
                          : null
                      }
                      alt={row.card_type}
                    />
                  </div>
                  <div className="card-cell">
                    <span>Card on Name</span>
                    <h4>{row.card_name}</h4>
                  </div>
                  <div className="card-cell">
                    <span>Card Number</span>
                    <h4>**** **** **** {row.card_number}</h4>
                  </div>
                  <div className="card-cell">
                    <span>Expiry Date</span>
                    <h4>{formatExpireDateForDisplay(row.expire_date)}</h4>
                  </div>
                  <div className="card-cell flex-row">
                    <Link className="edit-btn" to="" onClick={() => handleEdit(row)}>
                      <img src={EditIcon} alt="Edit" />
                    </Link>
                    <Link
                      className="delete-btn"
                      to=""
                      onClick={() => handleDelete(row.id)}
                    >
                      <img src={DeleteIcon} alt="Delete" />
                    </Link>
                  </div>
                </div>
              ))
            ) : (
              <p>No card found</p> // Show message if no cards exist
            )}
          </div>
        </div>
      </div>
      <div className={`${isActive ? "" : "isHide"}`}>
       <div className="mobile-product-header d-flex d-md-none">
        <button type="button" className="mph-back" onClick={handleToggle}>
          <img src={BackArrow} alt="Back" />
        </button>
        <h1 className="mph-title">Add New Card</h1>
      </div>
      <div className="tab-content-header d-none d-md-flex">
          <h3>
            <Link to="" className="backToList" onClick={handleToggle}>
              <img src={BackImg} alt="" />
            </Link>{" "}
            {formTitle}
          </h3>
        </div>
        
        <div className="new-address">
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col lg="6">
                <Form.Group className="mb-4" controlId="formFullNamel">
                  <Form.Label>
                    Name on Card <span>*</span>
                  </Form.Label>

                  <Form.Control
                    type="text"
                    placeholder="Enter name on card"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    isInvalid={!!errors.name}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.name}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-4" controlId="formFullNamel">
                  <Form.Label>
                    Card Number <span>*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    maxLength={16}
                    placeholder="Enter 16 digit card number"
                    value={cardNumber}
                    onChange={handleCardNumberChange}
                    isInvalid={!!errors.cardNumber}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.cardNumber}
                  </Form.Control.Feedback>
                </Form.Group>
                <Row>
                  <Col md="6">
                    <Form.Group controlId="formFullNamel">
                      <Form.Label>
                        Expiry Date <span>*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="MM-YYYY"
                        value={expireDate}
                        onChange={handleExpireDateChange}
                        onBlur={handleExpireDateBlur}
                        isInvalid={!!errors.expireDate}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.expireDate}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group controlId="formFullNamel">
                      <Form.Label>
                        Security Code <span>*</span>
                      </Form.Label>

                      <Form.Control
                        type="text"
                        maxLength={4}
                        placeholder="CVV"
                        value={securityCode}
                        onChange={handleSecurityCodeChange}
                        isInvalid={!!errors.securityCode}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.securityCode}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
              </Col>
              <Col md="12">
                <div className="bttn-group">
                  <Link
                    className="cutsom-bttn cancel-bttn"
                    onClick={handleToggle}
                  >
                    Cancel
                  </Link>

                  <Button className="cutsom-bttn" type="submit" disabled={loading}>
                  {loading ? (
                    <FontAwesomeIcon
                      icon={faSpinner}
                      spin
                      size="lg"
                      className="spinner-icon"
                    />
                  ) : (
                    <>
                     Save Card
                    </>
                  )}
                </Button>


                
                </div>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </>
  );
}
export default PaymentInfoComp;
